<template>
  <div class="service-plan">
    <div class="body-around">
      <dr-maintenance :info-list="aroundlist" />
    </div>
    <div v-if="repairsaround === false" class="check-content" @click="repairsaround = true">
      <p>查看报修内容</p>
      <img src="@/assets/images/icon_down@3x.png">
    </div>
    <div v-show="repairsaround" class="repairs-around">
      <!--信息展示部分👇-->
      <div class="repairs-around-content">
        <div v-if="imgFileList.length !== 0" class="repairs-around-info">
          <div class="celerity-repairs-title">
            <div class="repairs-title-img  describe-margin" />
            <div class="repairs-title-sign">图片描述:</div>
          </div>
          <div class="imgs-arr">
            <div v-for="(item,index) of imgFileList" :key="index" class="img-class-div">
              <img
                :src="item"
                class="img-class"
                alt=""
                @click="preview(index)"
              >
            </div>
          </div>
        </div>
        <div v-if="videoList.length !== 0" class="repairs-around-info">
          <div class="celerity-repairs-title">
            <div class="repairs-title-img  describe-margin" />
            <div class="repairs-title-sign">视频描述:</div>
          </div>
          <div class="demo1-video">
            <div v-for="(item,index) of videoList" :key="index" class="video-class">
              <video
                v-if="$store.state.isAndroid === true"
                :ref="`video_${index}`"
                :key="index"
                style="object-fit:fill"
                x5-video-player-fullscreen="true"
                class="myVideo"
                :poster="[$store.state.isAndroid ? '':require('@/assets/video@2x.png')]"
                @click="playVideo(index)"
              >    <source :src="item" type="video/mp4">
              </video>
              <video
                v-if="$store.state.isAndroid === false"
                :ref="`video_${index}`"
                :key="index"
                controls
                style="object-fit:fill"
                x5-video-player-fullscreen="true"
                class="myVideo"
                :poster="[$store.state.isAndroid ? '':require('@/assets/video@2x.png')]"
                @click="playVideo(index)"
              >    <source :src="item" type="video/mp4">
              </video>
            </div>
          </div>
        </div>
        <div v-if="audioList.length !== 0" class="repairs-around-info">
          <div class="celerity-repairs-title">
            <div class="repairs-title-img  describe-margin" />
            <div class="repairs-title-sign">语音描述:</div>
          </div>
          <div v-for="(item,index) of audioList" :key="index" class="repairs-content-voice-title">
            <div class="flex-start">
              <div class="content-voice-title">描述{{ index+1 }}：</div>
              <div
                class="repairs-title-voice"
                @click="handleWxConfig(item.Content,index,item.duration)"
              >
                <PlayIcon :id="'audio' + index" name="actAudio" style="" />
                <img :id="index" name="noAudio" src="@/assets/images/voice-icon.png" class="repairs-title-voice-icon">
                <div :style="[{width:item.duration > 60? '60': item.duration+'px'}]" />
                <audio :id="index" :src="item.Content" muted="muted" />
                <div class="repairs-title-voice-num">{{ item.duration }}"</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="this.textUpload" class="repairs-around-info">
          <div v-if="this.textUpload" class="celerity-repairs-title">
            <div class="repairs-title-img  describe-margin" />
            <div class="repairs-title-sign">文字描述:</div>
          </div>
          <div class="repairs-title-content-text">{{ this.textUpload }}</div>
        </div>
        <div class="repairs-around-info">
          <div v-if="fileRepairContentList.length !== 0" class="celerity-repairs-title">
            <div class="repairs-title-img  describe-margin" />
            <div class="repairs-title-sign">上传列表:</div>
          </div>
          <div v-for="(item,index) of fileRepairContentList" :key="index" class="file-name-list">
            <img alt="" src="@/assets/images/file-icon.png" class="file-icon">
            <div class="file-title">{{ fileNameList[index] }}文件</div>
          </div>
        </div>
        <!--信息展示部分👆-->
        <div class="check-content" @click="repairsaround = false">
          <p>收起</p>
          <img src="@/assets/images/icon_up@2x.png">
        </div>
      </div>
    </div>
    <van-steps active-color="#005BAC" class="van-steps" direction="vertical" inactive-icon="checked">
      <van-step v-for="(item,i) of maintainFlow" :key="i">
        <h3>{{ item.content }}</h3>
        <p>{{ item.inputDate }}</p>
        <span v-if="item.content == '已派员' || item.content == '已到达' || item.content == '已传输'">
          <p>维修工程师:   {{ item.operator }}</p>
          <a :href="'tel:' + item.phonenum">电话号:    {{ item.phonenum }}</a>
        </span>
      </van-step>
    </van-steps>
  </div>
</template>
<script>
import DrMaintenance from '@/components/Maintenance'
import { ImagePreview } from 'vant'
import PlayIcon from '@/components/playIcon'
import { removeLocalStore } from '../../utils'

export default {
  name: 'PlanParticular',
  components: { DrMaintenance, PlayIcon },
  data() {
    return {
      mp3: null, // 音频
      fileNameList: [], // 文件列表
      fileRepairContentList: [], // 文件上传列表
      audioList: [], // 语音列表
      textUpload: [], // 文字描述
      imgFileList: [], // 图片列表
      videoList: [], // 视频列表
      infolist: [], // 信息列表
      repairsInfoShow: [], // 展示报修信息
      uploadInventory: [], // 上传列表
      aroundlist: [], // 设备信息列表
      repairsaround: false,
      id: '',
      maintainFlow: []// 流程数组
    }
  },
  mounted() {
    this.id = Number(this.$route.query.key)
    this.getInfoList()
  },
  methods: {
    /* 播放视频*/
    playVideo(index) {
      const video = this.$refs[`video_${index}`][0]
      video.requestFullscreen()
      video.play()
    },
    /* 语音气泡动态图标*/
    handleWxConfig(src, index, time) {
      if (this.mp3) {
        this.mp3.pause()
      }
      document.getElementsByName('actAudio').forEach((item) => {
        item.style.display = 'none'
      })
      document.getElementsByName('noAudio').forEach((item) => {
        item.style.display = 'block'
      })
      document.getElementById(index).style.display = 'none'
      document.getElementById('audio' + index).style.display = 'block'
      this.mp3 = new Audio(src)
      this.mp3.play()
      setTimeout(() => {
        document.getElementById(index).style.display = 'block'
        document.getElementById('audio' + index).style.display = 'none'
      }, time * 1000)
    },
    /*
      图片点击预览
    */
    preview(index) {
      ImagePreview({
        images: this.imgFileList,
        startPosition: index
      })
    },
    // 获取列表信息
    getInfoList() {
      this.$api('REPAIR_INFO_H5', {
        UserRepairId: this.id
      }, true).then((res) => {
        if (res.code === 200) {
          removeLocalStore('redirect')
        }
        this.infolist = res.result
        this.maintainFlow = this.infolist.userRepairDisposeRecordList
        this.aroundlist = [
          { title: this.$t('SN'), content: this.infolist.deviceCode },
          { title: this.$t('productModel'), content: this.infolist.model },
          { title: this.$t('repairTime'), content: this.infolist.inputDate },
          { title: this.$t('serialNumber'), content: this.infolist.serialNumber }
        ]
        this.textUpload = this.infolist.textRepairContentList[0]
        this.videoList = this.infolist.videoRepairContentList
        this.imgFileList = this.infolist.imageRepairContentList
        this.audioList = this.infolist.audioRepairContentList
        this.fileRepairContentList = this.infolist.fileRepairContentList
        this.fileNameList = this.fileRepairContentList.map((item) => {
          item = item.split('.')[3]
          return item
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.myVideo{
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
}
.file-name-list {
  position: relative;
  width: 70px;
  font-size: 12px;
  color: #9ea7b2;
  margin-top: 15px;
  margin-left: 15px;
  .file-title{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 5px;
    text-align: center;
  }
  .file-icon{
    display: block;
    width: 70px;
    height: 70px;
    margin: auto;
  }
}
/*气泡框*/
.repairs-title-voice {
  align-items: center;
  display: flex;
  //width: 101.5px;
  height: 20px;
  margin-left: 24px;
  background-color: skyblue;
  border-bottom-color: skyblue;
  /*为了给after伪元素自动继承*/
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  padding: 5px 12px 5px 12px;
  box-sizing: border-box;
  position: relative;
  word-break: break-all;
}
/** 通过对小正方形旋转45度解决 **/
.repairs-title-voice::before {
  content: '';
  position: absolute;
  left: -2px;
  width: 10px;
  height: 10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
}
.repairs-title-content-text{
  margin-left: 20px;
  font-size: 12px;
  padding: 20px 10px;
  color: #808C9B;
  width: 200px;
  word-wrap: break-word;
  word-break: normal;
}
.repairs-title-voice-icon{
  width: 12px;
  height: 12px;
}
.repairs-title-voice-num{
  font-size: 12px;
  color: #FAF9FE;
  font-weight: 400;
}
.repairs-content-voice-title{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 10px;
  .content-voice-title{
    margin-left: 30px;
    width: 50px;
  }
}
.del-img{
  position:absolute;
  right: 0;
  background: rgba(0,0,0,0.9);
  color: #FAF9FE;
  width:20px;
  height: 20px;
  border-radius: 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.img-class{
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
}
.img-class-div{
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  margin-bottom: 10px;

}
.describe-margin {
  margin-left: 0;
}
.celerity-repairs-title {
  display: flex;
  align-items: center;

  .repairs-title-img {
    background-image: linear-gradient(#005BAC, #1DA6E3);
    width: 6px;
    height: 20px;
    border-radius: 5px;
    margin-left: 15px;
  }

  .repairs-title-sign {
    font-size: 14px;
    font-weight: 700;
    margin-left: 7px;
  }
}
.repairs-around-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .repairs-around-info {
    margin-top: 10px;
    .imgs-arr{
      margin-left: 30px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-flow: wrap;
    }
    .demo1-video {
      margin-left: 30px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-flow: wrap;
    }
  }
  button {
    margin-top: 20px;
    width: 25px;
    height: 25px;
    border-radius: 25px;
    border: none;
    color: #fff;
    font-size: 11px;
    background-color: #005BAC;
  }
  .repairs-content {
    display: flex;
    align-items: center;
    margin-top: 26px;

    .repairs-content-voice {
      display: flex;
      align-items: center;
    }

    .repairs-voice-second {
      font-size: 12px;
      color: #005BAC;
      margin-left: 10.5px;
      font-weight: 500;
    }

    .repairs-content-title {
      font-size: 14px;
      margin-left: 35.5px;
      font-weight: 500;
    }

    .repairs-title-content {
      font-size: 12px;
      color: #808C9B;
      margin-left: 24px;
      width: 200px;
      word-wrap: break-word;
      word-break: normal;
    }

    .repairs-title-img {
      height: 64px;
      margin-left: 25px;
    }
  }
}
.repairs-title-content {
  font-size: 12px;
  color: #808C9B;
  margin-left: 24px;
  width: 200px;
  word-wrap: break-word;
  word-break: normal;
}
.repairs-content-title {
  font-size: 14px;
  margin-left: 35.5px;
  font-weight: 500;
}
::v-deep .van-step--vertical:not(:last-child)::after {
  border-bottom-width: 0
}
.service-plan {
  padding: 13px;
  border: none;
  .van-steps {
    min-height: 260px;

    .van-step {
      font-size: 12px;
      padding-bottom: 12px;
      margin-top: 18px;

      h3 {
        margin-top: -10px;
      }

      p {
        margin-top: 5.5px;
      }
    }
  }

  .schedule-around {
    margin-top: 32px;
    display: flex;
    flex-direction: column;

    .schedule-around-time {
      font-size: 12px;
      color: #005BAC;
      margin-top: 10px;
    }

    .schedule-around-title {
      margin-top: 11px;
      color: #005BAC;
      font-size: 12px;
    }
  }

  .repairs-around {
    background-color: #fff;
    font-weight: 700;
    padding-top: 10px;

    .repairs-around-button {
      width: 110px;
      height: 27px;
      font-size: 12px;
      background-color: #CEE1F7;
      color: #005BAC;
      margin-bottom: 33px;
      border: none;
      margin-left: 100px;
      font-weight: 500;
    }

    .repairs-around-list {
      margin-left: 20px;
    }

    .repairs-around-p {
      font-size: 14px;
      margin-left: 17px;
    }
  }

  .check-content {
    height: 66px;
    background-color: #fff;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      font-size: 13px;
      color: #005BAC;
      font-weight: 700;
    }

    img {
      width: 13px;
      height: 7px;
      margin-left: 7px;
    }
  }
}
</style>
